/* Ruts Atelier — Barra ATC sticky (móvil). Se muestra cuando el buy box nativo
   (product-form) sale del viewport hacia arriba. Reutiliza el botón nativo de compra
   (simula su click) para respetar siempre la variante seleccionada. */
(function () {
  "use strict";
  function init() {
    var bar = document.getElementById("ruts-sticky-atc");
    var btn = document.getElementById("ruts-sticky-atc-btn");
    var form = document.querySelector("product-form");
    if (!bar || !btn || !form) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle("is-visible", show);
          bar.setAttribute("aria-hidden", show ? "false" : "true");
        });
      },
      { threshold: 0 }
    );
    io.observe(form);

    btn.addEventListener("click", function () {
      var nativeBtn = form.querySelector('button[type="submit"], [name="add"]');
      if (nativeBtn) nativeBtn.click();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
